import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

// Single source of truth for the project connection. The publishable (anon)
// key is public by design; keeping one copy means a project or key rotation is
// a one-line change.
export const SUPABASE_URL = "https://okswnspuiirygzzmoxmf.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9rc3duc3B1aWlyeWd6em1veG1mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUwNjc2MjEsImV4cCI6MjA1MDY0MzYyMX0.2tVugilIBY53kjgyUwl0UnxgfG_FnCXt_6OPik2Lzrs";

export const createSupabaseClient = (supabaseToken: string | null) => {
  return createClient<Database>(
    SUPABASE_URL,
    SUPABASE_PUBLISHABLE_KEY,
    {
      global: {
        headers: {
          Authorization: `Bearer ${supabaseToken}`,
        },
      },
    }
  );
};